const hasNumber = (password: string) => {
    return password.match(/\d+/g) ? 1 : 0
}

const hasSpecialCharacter = (password: string) => {
    return password.match(/[ `!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/) ? 1 : 0
}

const hasLowercaseCharacter = (password: string) => {
    return password.match(/[a-z]/) ? 1 : 0
}

const hasUppercaseCharacter = (password: string) => {
    return password.match(/[A-Z]/) ? 1 : 0
}

const checkStrength = (password: string) => {
    return (
        hasNumber(password) +
        hasSpecialCharacter(password) +
        hasLowercaseCharacter(password) +
        hasUppercaseCharacter(password)
    )
}

export default checkStrength
